<template>
  <div>
    <div v-if="isLoading">
      <div id="loading-animation">
        Loading...
      </div>
    </div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="mb-3 steps-transparent"
      @on-complete="formSubmitted()"
    >
      <!-- Company Details tab -->
      <tab-content
        title="Basic Details"
        icon="feather icon-file-text"
        :before-change="validationForm"
      >
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" lg="6" md="6" sm="12" class="mb-2">
              <div class="mb-3 mt-2">
                <b-form-group>
                  <label for="existing-vendor">
                    Are you existing vendor?
                    <i
                      class="feather icon-info text-primary"
                      @click="getInfoPopup(existingVendorInfo)"
                    ></i>
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    name="Existing Vendor"
                  >
                    <b-form-checkbox
                      id="existing-vendor"
                      class="custom-control-primary"
                      name="check-button"
                      @change="
                        () => {
                          existing = !existing;
                        }
                      "
                      switch
                    />
                    <small class="text-danger"
                      >Please check if you have vendor code.</small
                    >
                  </validation-provider>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="12" class="mb-2">
              <div class="mb-3 mt-2">
                <b-form-group>
                  <label for="vendor-type">
                    Vendor Type
                    <i
                      class="feather icon-info text-primary"
                      @click="getInfoPopup(vendorTypeInfo)"
                    ></i>
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    name="Vendor Type"
                    rules="required"
                  >
                    <v-select
                      v-model="vendorType"
                      id="vendor-type"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :state="errors.length > 0 ? false : null"
                      label="title"
                      placeholder="Enter your Vendor Type"
                      :options="vendorTypeList"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-3" v-if="existing">
            <b-col lg="8" md="8" sm="12">
              <b-form-group label="Vendor Code" label-for="vendor-code">
                <validation-provider #default="{ errors }" name="Vendor Code">
                  <b-form-input
                    id="vendor-code"
                    v-model="vendorCode"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4" md="4" sm="12" class="my-auto">
              <b-button variant="primary" @click.prevent="checkVendorExisting">
                Verify Vendor Code
              </b-button>
            </b-col>
          </b-row>
          <b-row cols="12" class="mb-3">
            <b-col lg="12" md="12" sm="12"> </b-col>
            <b-col md="6" lg="6" sm="12">
              <label class="company-type-label"
                >Company Type
                <i
                  class="feather icon-info text-primary"
                  @click="getInfoPopup(companyTypeInfo)"
                ></i
              ></label>
              <b-form-group>
                <b-form-radio
                  v-model="companyType"
                  value="PVT Company (Private Limited Company)"
                  name="companyType"
                  id="pvt-company"
                  @change="
                    () => {
                      cinNum = true;
                      shopActNum = false;
                    }
                  "
                >
                  PVT Company (Private Limited Company)
                </b-form-radio>
              </b-form-group>
              <b-form-group>
                <b-form-radio
                  v-model="companyType"
                  value="LTD Company (Limited Company)"
                  name="companyType"
                  id="ltd-company"
                  @change="
                    () => {
                      cinNum = true;
                      shopActNum = false;
                    }
                  "
                >
                  LTD Company (Limited Company)
                </b-form-radio>
              </b-form-group>
              <b-form-group>
                <b-form-radio
                  v-model="companyType"
                  value="LLP (Limited Liability Partnership)"
                  name="companyType"
                  id="llp-company"
                  @change="
                    () => {
                      cinNum = true;
                      shopActNum = false;
                    }
                  "
                >
                  LLP (Limited Liability Partnership)
                </b-form-radio>
              </b-form-group>
              <b-form-group>
                <b-form-radio
                  v-model="companyType"
                  value="OPC (One Person Company)"
                  name="companyType"
                  id="opc-company"
                  @change="
                    () => {
                      cinNum = true;
                      shopActNum = false;
                    }
                  "
                >
                  OPC (One Person Company)
                </b-form-radio>
              </b-form-group>
              <b-form-group>
                <b-form-radio
                  v-model="companyType"
                  value="trustCompany"
                  name="Trust"
                  id="trust-company"
                  @change="
                    () => {
                      cinNum = true;
                      shopActNum = false;
                    }
                  "
                >
                  Trust
                </b-form-radio>
              </b-form-group>
              <b-form-group>
                <b-form-radio
                  v-model="companyType"
                  value="Proprietor"
                  name="companyType"
                  id="proprietor-company"
                  @change="
                    () => {
                      cinNum = false;
                      shopActNum = true;
                    }
                  "
                >
                  Proprietor
                </b-form-radio>
              </b-form-group>
              <b-form-group>
                <b-form-radio
                  v-model="companyType"
                  value="Firm"
                  name="companyType"
                  id="firm"
                  @change="
                    () => {
                      cinNum = false;
                      shopActNum = true;
                    }
                  "
                >
                  Firm
                </b-form-radio>
              </b-form-group>
              <b-form-group>
                <b-form-radio
                  v-model="companyType"
                  value="Unemployed Engineer"
                  name="companyType"
                  id="unempengineer"
                  @change="
                    () => {
                      cinNum = false;
                      shopActNum = false;
                    }
                  "
                >
                Unemployed Engineer
                </b-form-radio>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="6" sm="12">
              <b-form-group>
                <label for="pan-number"
                  >PAN Number
                  <i
                    class="feather icon-info text-primary"
                    @click="getInfoPopup(panNumberInfo)"
                  ></i
                ></label>
                <validation-provider
                  #default="{ errors }"
                  name="PAN Number"
                  rules="checkPAN|required"
                >
                  <div class="d-flex">
                    <b-form-input
                      id="pan-number"
                      v-model="PANNumber"
                      placeholder="Enter Pan Number"
                      :state="errors.length > 0 ? false : null"
                      @change="checkPANValidation"
                    />
                    <span v-if="isValidPan" class="my-auto ml-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#388E3C"
                          d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z"
                        />
                      </svg>
                    </span>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small v-if="panError.isError" class="text-danger"
                    >{{ panError.message }}</small
                  >
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <label for="company-name">
                  Company Name
                  <i
                    class="feather icon-info text-primary"
                    @click="getInfoPopup(companyNameInfo)"
                  ></i>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Company Name"
                  rules="required"
                >
                  <!-- <v-select
                    v-model="companyName"
                    id="company-name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    placeholder="Eg. ABC PVT LTD"
                    :options="companyNameList"
                    @input="companyDetailsRequest($event)"
                  /> -->
                  <b-form-input
                    id="company-name"
                    v-model="companyName"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Please enter Company Name"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                v-if="cinNum"
                label="CIN Number (Corporate Identity Number)"
                label-for="cin-number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="CIN Number"
                  rules="required"
                >
                  <b-form-input
                    id="cin-number"
                    v-model="cinNumber"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Your CIN Number will be display here"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                v-if="shopActNum"
                label="Shop Act Certificate Number"
                label-for="shopact-number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Shop Act Certificate Number"
                  rules="required"
                >
                  <b-form-input
                    id="shopact-number"
                    v-model="shopActNumber"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Your shop act number will be display here"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="Director Name"
                label-for="comopany-director-name"
              >
                <b-form-input
                  id="comopany-director-name"
                  v-model="companyDetailsResponse.directorName"
                  type="text"
                  placeholder="Directors Name"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group label="Company Address" label-for="company-address">
                <b-form-input
                  id="company-address"
                  v-model="companyDetailsResponse.companyAddress"
                  type="text"
                  placeholder="Company Address"
                >
                </b-form-input>
              </b-form-group>
              <b-row>
                <b-col md="6" lg="6" sm="12">
                  <b-form-group label="Pincode" label-for="pincode">
                    <b-form-input
                      id="pincode"
                      v-model="pincode"
                      type="text"
                      placeholder="Enter Pincode"
                      @change="getAddressDetails()"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6" lg="6" sm="12">
                  <b-form-group label="City" label-for="city">
                    <b-form-input
                      id="city"
                      v-model="city"
                      type="text"
                      placeholder="Enter City"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" lg="6" sm="12">
                  <b-form-group label="State" label-for="state">
                    <b-form-input
                      id="state"
                      v-model="state"
                      type="text"
                      placeholder="Enter State"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" lg="6" sm="12">
                  <b-form-group label="Country" label-for="country">
                    <b-form-input
                      id="country"
                      v-model="country"
                      type="text"
                      placeholder="Enter Country"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- More Company details tab -->
      <tab-content
        title="Company Details"
        :before-change="validationFormInfo"
        icon="feather icon-briefcase"
      >
        <validation-observer ref="infoRules" tag="form">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="pan-number"
                  >PAN Number
                  <i
                    class="feather icon-info text-primary"
                    @click="getInfoPopup(panNumberInfo)"
                  ></i
                ></label>
                <validation-provider
                  #default="{ errors }"
                  name="PAN Number"
                  rules="checkPAN|required"
                >
                  <div class="d-flex">
                    <b-form-input
                      id="pan-number"
                      v-model="PANNumber"
                      placeholder="Enter Pan Number"
                      :state="errors.length > 0 ? false : null"
                      @change="checkPANValidation"
                      disabled
                    />
                    <span v-if="isValidPan" class="my-auto ml-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#388E3C"
                          d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z"
                        />
                      </svg>
                    </span>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                description="Upload the document in .jpg or .png image format only."
              >
                <label
                  >PAN Card Document
                  <i
                    class="feather icon-info text-primary"
                    @click="getInfoPopup(panDocumentInfo)"
                  ></i
                ></label>
                <validation-provider
                  #default="{ errors }"
                  name="PAN Card Document"
                  rules="required"
                >
                  <b-form-file
                    id="pancard-doc"
                    accept=".jpg, .png, .pdf"
                    v-model="panCardDoc"
                    @change="readPanCardDoc()"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="gst-number"
                  >GST Number
                  <i
                    class="feather icon-info text-primary"
                    @click="getInfoPopup(gstNumberInfo)"
                  ></i
                ></label>
                <validation-provider
                  #default="{ errors }"
                  name="GST Number"
                  rules="checkGST|required"
                >
                  <div class="d-flex">
                    <b-form-input
                      id="gst-number"
                      v-model="GSTNumber"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter GST Number"
                      @change="checkGSTValidation"
                    />
                    <span v-if="isValidGST" class="my-auto ml-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#388E3C"
                          d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z"
                        />
                      </svg>
                    </span>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                description="Upload the document in .jpg, .png or .pdf formats only."
              >
                <label>
                  GST Certificate Document
                  <i
                    class="feather icon-info text-primary"
                    @click="getInfoPopup(gstCertificateInfo)"
                  ></i>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="GST Certificate Document"
                  rules="required"
                >
                  <b-form-file
                    id="gst-certoficate-doc"
                    accept=".jpg, .png, .pdf"
                    v-model="gstCertificate"
                    @change="readGSTDoc()"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="border rounded py-2">
            <b-col cols="12">
              <div class="d-flex justify-content-between">
                <h4>
                  Bank Details
                  <i
                    class="feather icon-info text-primary"
                    @click="getInfoPopup(bankDetailsInfo)"
                  ></i>
                </h4>
                <!-- <b-button variant="primary" @click.prevent="addBankFields">Add Bank Account</b-button -->
                <!-- > -->
              </div>
              <!-- <div v-for="(acc, index) in bankAccounts" :key="index"> -->
              <b-row class="mt-2">
                <b-col lg="6" md="6" sm="12">
                  <b-form-group label="IFSC Code" label-for="ifsc-code">
                    <validation-provider
                      #default="{ errors }"
                      name="IFSC Code"
                      rules="checkIFSC|required"
                    >
                      <b-form-input
                        id="ifsc-code"
                        v-model="bankIFSC"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Enter IFSC Code"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                  <b-form-group label="Account Number" label-for="acc-number">
                    <validation-provider
                      #default="{ errors }"
                      name="Account Number"
                      rules="required"
                    >
                      <b-form-input
                        id="acc-number"
                        v-model="bankAccountNumber"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Enter Account Number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col lg="6" md="6" sm="12">
                  <b-form-group
                    label="Account Holder Name"
                    label-for="acc-holder"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Account Holder Name"
                      rules="required"
                    >
                      <b-form-input
                        id="acc-holder"
                        v-model="bankAccountHolder"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Enter Account Holder Name"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- <b-col lg="2" md="2" sm="12" class="d-flex">
                    <b-button
                      variant="danger"
                      class="my-auto lead"
                      @click="removeBankAccount(index)"
                    >
                      <i class="feather icon-trash"></i>
                    </b-button>
                  </b-col> -->
              </b-row>
              <!-- </div> -->
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="4">
              <b-form-group>
                <label for="contact-name">
                  Contact Person Name
                  <i
                    class="feather icon-info text-primary"
                    @click="getInfoPopup(contactPersonInfo)"
                  ></i>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Contact Person Name"
                  rules="required"
                >
                  <div class="d-flex">
                    <b-form-input
                      id="contact-name"
                      v-model="contactPersonName"
                      placeholder="Enter Contact person name"
                      :state="errors.length > 0 ? false : null"
                    />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="email">Contact Person Email</label>
                <validation-provider
                  #default="{ errors }"
                  name="Contact Person Email"
                  rules="required"
                >
                  <div class="d-flex">
                    <b-form-input
                      id="email"
                      v-model="email"
                      placeholder="Enter Contact person email"
                      :state="errors.length > 0 ? false : null"
                    />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                description="This mobile number is used as username for login. And you will receive the OPT on same number"
              >
                <label for="mobile-number">
                  Mobile Number
                  <i
                    class="feather icon-info text-primary"
                    @click="getInfoPopup(mobileNumberInfo)"
                  ></i>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Mobile Number"
                  rules="checkMobileNumber|required"
                >
                  <div class="d-flex">
                    <b-form-input
                      id="mobile-number"
                      v-model="mobileNumber"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Enter Mobile Number"
                      @change="validateAndSendOTP"
                    />
                    <span v-if="isValidMobile" class="my-auto ml-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#388E3C"
                          d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z"
                        />
                      </svg>
                    </span>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Verification  -->
      <tab-content
        title="Verification"
        :before-change="validationFormAddress"
        icon="feather icon-user-check"
      >
        <validation-observer ref="addressRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2 text-center">
              <h4 class="mb-0">Verification of OTP</h4>
            </b-col>
            <b-col md="3" lg="3" class="mx-auto">
              <b-form-group label-for="otp">
                <validation-provider
                  #default="{ errors }"
                  name="OTP"
                  rules="required|isValidOTP"
                >
                  <div class="d-flex">
                    <Cleave
                      id="otp"
                      v-model="mobileOTP"
                      class="form-control"
                      :state="errors.length > 0 ? false : null"
                      :raw="false"
                      :options="mobileOTPOption"
                      placeholder="Enter received OTP"
                      @blur.native="verifyOTP"
                    />
                    <span v-if="isValidOTP" class="my-auto ml-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#388E3C"
                          d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z"
                        />
                      </svg>
                    </span>
                  </div>
                  <div class="d-flex justify-content-between mt-2">
                    {{ countDown }}
                    <b-button variant="primary" :disabled="enableResendOTP"
                      >Resend OTP</b-button
                    >
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12" class="mb-2 text-center">
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Cpatcha"
                  rules="required"
                >
                  <label>Addition of {{ number1 }} and {{ number2 }} = ?</label>
                  <div
                    class="
                      d-flex
                      flex-row
                      align-items-center
                      justify-content-center
                    "
                  >
                    <label type="number">{{ number1 }}&nbsp; + &nbsp;</label>
                    <label type="number">{{ number2 }}&nbsp; = &nbsp;</label>
                    <b-form-input
                      type="number"
                      style="width: 5%"
                      v-model="totalNumber"
                      :state="errors.length > 0 ? false : null"
                    >
                    </b-form-input>
                    &nbsp;
                    <span v-if="verifyCaptcha" class="my-auto ml-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#388E3C"
                          d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z"
                        />
                      </svg>
                    </span>
                    &nbsp;
                    <b-button
                      variant="info"
                      @click.prevent="
                        () => {
                          if (number1 + number2 == totalNumber) {
                            verifyCaptcha = true;
                          } else {
                            verifyCaptcha = false;
                          }
                        }
                      "
                      >Verify</b-button
                    >
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small v-if="!verifyCaptcha" class="text-danger"
                    >Please enter the addition of {{ number1 }} +
                    {{ number2 }} = ? correctly.</small
                  >
                </validation-provider>
              </b-form-group>
              <!-- <input type="number" v-model="number1" class="" /> +
              <input type="number" v-model="number2" /> =
              <input type="number" v-model="totalNumber" /> -->
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Upload Documents -->
      <!-- <tab-content
        title="Upload Documents"
        :before-change="validationFormSocial"
        icon="feather icon-upload-cloud"
      >
        <validation-observer ref="socialRules" tag="form">
          <b-row>
            <b-col md="6">
              <b-form-group
                label="PAN Card Document"
                label-for="pancard-doc"
                description="Upload the document in .jpg or .png image format only."
              >
                <validation-provider
                  #default="{ errors }"
                  name="PAN Card Document"
                >
                  <b-form-file
                    id="pancard-doc"
                    accept="image/jpeg, image/png, image/gif"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content> -->
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import useJwt from "@/auth/jwt/useJwt";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Ripple from "vue-ripple-directive";
import { VueRecaptcha } from "vue-recaptcha";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadio,
  BCardText,
  BButton,
  BFormFile,
  VBPopover,
} from "bootstrap-vue";
import Cleave from "vue-cleave-component";
import { required, email } from "@validations";
import { codeIcon } from "./code";
import store from "@/store";
import axios from "axios";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BCardText,
    vSelect,
    Cleave,
    BButton,
    BFormFile,
    BFormRadio,
    BFormInvalidFeedback,
    BFormCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    VueRecaptcha,
  },
  directives: {
    "b-popover": VBPopover,
    Ripple,
  },
  data() {
    return {
      password: "admin",
      userEmail: "admin@demo.com",
      number1: Math.floor(Math.random() * 10),
      number2: Math.floor(Math.random() * 30),
      totalNumber: "",
      selectedContry: "",
      selectedLanguage: "",
      name: "",
      emailValue: "",
      PasswordValue: "",
      passwordCon: "",
      first_name: "",
      last_name: "",
      address: "",
      landMark: "",
      pincode: "",
      twitterUrl: "",
      facebookUrl: "",
      googleUrl: "",
      linkedinUrl: "",
      city: "",
      country: "",
      state: "",
      required,
      email,
      codeIcon,
      countryName: [
        { value: "select_value", text: "Select Value" },
        { value: "Russia", text: "Russia" },
        { value: "Canada", text: "Canada" },
        { value: "China", text: "China" },
        { value: "United States", text: "United States" },
        { value: "Brazil", text: "Brazil" },
        { value: "Australia", text: "Australia" },
        { value: "India", text: "India" },
      ],
      languageName: [
        { value: "nothing_selected", text: "Nothing Selected" },
        { value: "English", text: "English" },
        { value: "Chinese", text: "Mandarin Chinese" },
        { value: "Hindi", text: "Hindi" },
        { value: "Spanish", text: "Spanish" },
        { value: "Arabic", text: "Arabic" },
        { value: "Malay", text: "Malay" },
        { value: "Russian", text: "Russian" },
      ],
      companyName: "",
      companyNameList: [
        {
          value: "ABC Company Pvt. Ltd",
          title: "ABC Company Pvt. Ltd",
        },
        {
          value: "DEF Company Pvt. Ltd",
          title: "DEF Company Pvt. Ltd",
        },
        {
          value: "PQR Firm",
          title: "PQR Firm",
        },
        {
          value: "XYZ NGO",
          title: "XYZ NGO",
        },
        {
          value: "TCS",
          title: "TCS",
        },
      ],
      companyType: "",
      pvtCompany: false,
      ltdCompany: false,
      llpCompany: false,
      opcCompany: false,
      trustCompany: false,
      proprietorCompany: false,
      firmCompany: false,
      cinNum: false,
      shopActNum: false,
      existing: false,
      vendorCode: "",
      cinNumber: "",
      shopActNumber: "",
      showDetails: false,
      companyDetailsResponse: {
        directorName: "",
        companyAddress: "",
      },
      isValidPan: false,
      PANNumber: "",
      isValidGST: false,
      GSTNumber: "",
      bankIFSC: "",
      bankAccountNumber: "",
      bankAccountHolder: "",
      bankAccounts: [
        {
          bankIFSC: "",
          bankAccountNumber: "",
        },
      ],
      contactPersonName: "",
      isValidMobile: false,
      mobileNumber: "",
      mobileOTPOption: {
        blocks: [1, 1, 1, 1],
      },
      mobileOTP: "",
      sentOTP: "",
      isValidOTP: false,
      countDown: "2:00",
      enableResendOTP: true,
      gstCertificate: [],
      panCardDoc: [],
      gstCertificateBase64: "",
      panCardDocBase64: "",
      vendorTypeList: [
        {
          value: "labour supply contractor",
          title: "Labour Supply Contractor",
        },
        {
          value: "civil contractor",
          title: "Civil Contractor",
        },
        {
          value: "material supply contractor",
          title: "Material Supply Contractor",
        },
        {
          value: "electrical contractor",
          title: "Electrical Contractor",
        },
        {
          value: "electro mechanical contractor",
          title: "Electro - Mechanical Contractor",
        },
        {
          value: "other",
          title: "Other",
        },
      ],
      vendorType: "",
      vendorTypeInfo: {
        title: "Vendor Type",
        text: "Please mention which type of vendor you are from list. This is very important and required field as following process is depending on it. If your type is not listed then please select 'Other' vendor type.",
        icon: "info",
      },
      existingVendorInfo: {
        title: "is Existing Vendor?",
        text: "If you have existing vendor code and not registered yet on this platform then you can checked this out.",
      },
      companyTypeInfo: {
        title: "Company Type",
        text: "Please select your company type from listed below types.",
      },
      companyNameInfo: {
        title: "Company Name",
        text: "Please enter your registered and valid name. As you start typing you can see your name sorting below in list and select it from that list.",
      },
      panNumberInfo: {
        title: "PAN Number",
        text: "Please enter PAN Number below. If you have private limited company please add company PAN number and if not please enter individual PAN Number",
      },
      gstNumberInfo: {
        title: "GST Number",
        text: "Please enter GST Number which belongs to your company.",
      },
      panDocumentInfo: {
        title: "PAN Card PDF",
        text: "Upload the PAN Card copy of PDF or Image. Allowed file types are .pdf/.jpg/.png only.",
      },
      gstCertificateInfo: {
        title: "GST Certificate PDF",
        text: "Upload the GST Certificate copy of PDF or Image. Allowed file types are .pdf/.jpg/.png only.",
      },
      bankDetailsInfo: {
        title: "Bank Details",
        text: "Please enter valid IFSC code and Account Number as per your bank passbook. If you want to add more than one bank account please click on 'Add Bank Account' btton and will be available new row with fields. On clicking on trash button you can delete the row.",
      },
      contactPersonInfo: {
        title: "Contact Person Name",
        text: "Please enter the contact person name who is authorised to do changes in future as it will be feasible to contact for information if required.",
      },
      mobileNumberInfo: {
        title: "Mobile Number",
        text: "This mobile number is used as username for login. And you will receive the OPT on same number.",
      },
      vendor: [],
      verifyCaptcha: false,
      isLoading: false,
      panError: {
        isError: false,
        message: "Already Registered Please connect Admin."
      }
    };
  },
  methods: {
    formSubmitted() {
      // let panCardDoc = "";
      // let gstDoc = "";
      this.isLoading = true;
      var self = this;
      // console.log(event);
      // return
      const reader = new FileReader();
      reader.onload = (event) => {
        // panCardDoc = event.target.result;
        // console.log(event.target.result);
        this.readPanCardDoc(event);
        // self.panCardDocBase64 = event.target.result;
      };

      reader.readAsDataURL(document.querySelector("#pancard-doc").files[0]);
      // var panCardDoc = (event) => {
      //   this.panCardDocBase64 = event.target.result;
      //   console.log(event.target.result);
      // };
      // reader.readAsText(document.querySelector("#pancard-doc").files[0]);
      const reader1 = new FileReader();
      reader1.onload = (event) => {
        this.readGSTDoc(event)
        // self.gstCertificateBase64 = event.target.result;
        
      };
      reader1.readAsDataURL(
        document.querySelector("#gst-certoficate-doc").files[0]
      );


      // console.log(self.panCardDocBase64, self.gstCertificateBase64);

      // this.$swal({
      //   title: "Process the Payment?,",
      //   text: "Please pay minimal amount and then process to login.",
      //   icon: "warning",
      //   showCancelButton: true,
      //   customClass: {
      //     confirmButton: "btn btn-primary",
      //     cancelButton: "btn btn-danger ml-1",
      //   },
      //   showClass: {
      //     popup: "animate__animated animate__bounceIn",
      //   },
      //   buttonsStyling: false,
      // }).then((result) => {
      // if (result.value) {

      this.password = this.generatePassword();

      const vendorDetails = {
        existing: this.existing,
        vendorType: this.vendorType,
        vendorCode: this.vendorCode,
        companyType: this.companyType,
        companyName: this.companyName,
        cinNumber: this.cinNumber,
        shopActNumber: this.shopActNumber,
        owners: this.companyDetailsResponse,
        panNumber: this.PANNumber,
        gstNumber: this.GSTNumber,
        panCard: this.panCardDocBase64,
        gstCertificate: this.gstCertificateBase64,
        bankAccountNumber: this.bankAccountNumber,
        bankIFSC: this.bankIFSC,
        bankAccountHolder: this.bankAccountHolder,
        contactPerson: this.contactPersonName,
        mobileNumber: this.mobileNumber,
        pincode: this.pincode,
        city: this.city,
        state: this.state,
        country: this.country,
        email: this.email,
        username: this.username,
        password: this.password,
      };

     

      axios
        .post(
          "https://innomiseapi.com/vendor_api/public/api/vendors",
          vendorDetails
        )
        .then((data) => {
          console.log(data);
          let message ="Your Registration is done Successfully in PMC IWMS. Your Login Credentials are:%nUsername: "+this.mobileNumber + "%nPassword: "+ this.password +"%nLink: https://pmciwms.in/site/login -PMC INIWMS";
          var data = JSON.stringify({
            "numbers": "91" + this.mobileNumber,
            "sender": "INIWMS",
            "message": message
          });

          var config = {
            method: 'post',
            url: 'https://innomiseapi.com/vendor_api/public/api/sendsms',
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };

          axios(config)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
          });

          var data = JSON.stringify({
            "company_name": this.companyName,
            "email": this.email,
            "subject": "Congratulations! Successfully Registered with IWMS",
            "message": "<br><br>Congratulations! You are successfully registered on IWMS platform. <br><br>Your Login Credentials are: <br><br><b>Username:</b> "+ this.mobileNumber +" <br><b>Password:</b> "+ this.password +" <br><br> Please visit this link to login: <a href='https://pmciwms.in/site/login' target='_blank'>https://pmciwms.in/site/login</a>"
          });

          var config = {
            method: 'post',
            url: 'https://innomiseapi.com/vendor_api/public/api/sendMail',
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };

          axios(config)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
          });





          this.$swal({
            title: "Successfully Registered",
            text: "Please check your phone for further process as we send you details with SMS and Email.",
            icon: "success",
            showCancelButton: true,
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-danger ml-1",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        }).then((okay)=>{
          // console.log(okay);
          // if(okay){
            this.isLoading = false;
            window.location.href = "https://pmciwms.in";
          // }
        })
        .catch((error) => console.error(error));

      store.commit("app/UPDATE_VENDOR_DETAILS", vendorDetails);

      // useJwt
      //   .login({
      //     email: this.userEmail,
      //     password: this.password,
      //   })
      //   .then((response) => {
      //     const { userData } = response.data;
      //     useJwt.setToken(response.data.accessToken);
      //     useJwt.setRefreshToken(response.data.refreshToken);
      //     localStorage.setItem("userData", JSON.stringify(userData));
      //     this.$ability.update(userData.ability);

      //     // ? This is just for demo purpose as well.
      //     // ? Because we are showing eCommerce app's cart items count in navbar
      //     this.$store.commit(
      //       "app-ecommerce/UPDATE_CART_ITEMS_COUNT",
      //       userData.extras.eCommerceCartItemsCount
      //     );

      //     // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
      //     this.$router
      //       .replace(getHomeRouteForLoggedInUser(userData.role))
      //       .then(() => {
      //         this.$toast({
      //           component: ToastificationContent,
      //           position: "top-right",
      //           props: {
      //             title: `Welcome ${userData.fullName || userData.username}`,
      //             icon: "CoffeeIcon",
      //             variant: "success",
      //             text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
      //           },
      //         });
      //       });
      //   })
      //   .catch((error) => {
      //     this.$refs.loginForm.setErrors(error.response.data.error);
      //   });
      // }
      // });
    },
    generatePassword() {
        var length = 6,
            charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
            retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    },

    readPanCardDoc() {
      var self = this;
      const reader = new FileReader();
      reader.onload = (event) => {
        // panCardDoc = event.target.result;
        // console.log(event.target.result);
        // this.panCardDocFun(event);
        self.panCardDocBase64 = event.target.result;
      };

      reader.readAsDataURL(document.querySelector("#pancard-doc").files[0]);
    },
    readGSTDoc() {
      var self = this;
      const reader = new FileReader();
      reader.onload = (event) => {
        // panCardDoc = event.target.result;
        // console.log(event.target.result);
        // this.panCardDocFun(event);
        self.gstCertificateBase64 = event.target.result;
      };

      reader.readAsDataURL(document.querySelector("#pancard-doc").files[0]);
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationFormSocial() {
      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    companyDetailsRequest(e) {
      // console.log(this.companyName);
      if (this.cinNum) {
        this.cinNumber = "U67190TN2014PTC096978";
      } else {
        this.shopActNumber = "U67190TN2019PTC093252";
      }
      this.companyDetailsResponse = {
        directorName: "Mr. Ramesh Desai",
        companyAddress:
          "380, Mumbai Pune Highway, Pimpri Chinchwad, Pune, Maharashtra, India, 411018",
      };
      this.showDetails = true;
    },
    checkPANValidation() {
      let regPan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
      var self = this;
      this.PANNumber = this.PANNumber.toUpperCase();
      if (regPan.test(this.PANNumber)) {
        var data = JSON.stringify({
          "pan_no": this.PANNumber
        });

        var config = {
          method: 'post',
          url: 'https://innomiseapi.com/vendor_api/public/api/checkpan',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };

        axios(config)
        .then(function (response) {
          // console.log(response.data);
          self.vendor = response.data;
          self.isValidPan = true;
        // this = self;
          var msg = self.vendor.message;
          if(msg.includes('Already')){
            console.log(self.vendor.username);
            self.panError.isError = true;
            self.panError.message = `Contractor Already Existed. Please connect with Administrator. Your Username is ${self.vendor.username}`;
            // document.querySelector('.wizard-btn').setAttribute('disabled') = true;
            // console.log(document.querySelector('.wizard-btn'));
            // this.$swal({
            //   title: 'Contractor Already Existed!',
            //   text: `Contractor Already Existed. Please connect with Administrator. Your Username is ${self.vendor.username}`,
            //   icon: "error",
            //   customClass: {
            //     confirmButton: "btn btn-primary",
            //   },
            //   buttonsStyling: false,
            // });
            const popupMsg = {
              title: 'Contractor Already Existed!',
              text: `Contractor Already Existed. Please connect with Administrator. Your Username is ${self.vendor.username}`,
              icon: "error"
            };

            self.getCustomPopup(popupMsg);
            
          } else if(msg.includes('Success')){
            // console.log();
            let vendorD = self.vendor.vendor
            self.companyName = vendorD.vendor_name;
            self.companyDetailsResponse.companyAddress = vendorD.street;
            self.pincode = vendorD.postal_code;
            self.bankAccountNumber = vendorD.bank_account;
            self.bankIFSC = vendorD.bank_ifsc;
            self.GSTNumber = vendorD.gst_number;
            // document.querySelector('.wizard-btn').setAttribute('disabled') = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
        
      } else {
        this.isValidPan = false;
      }
    },
    checkGSTValidation() {
      let regPan =
        /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9a-zA-Z]){1}([Z]){1}([0-9a-zA-Z]){1}?$/;
      this.GSTNumber = this.GSTNumber.toUpperCase();
      if (regPan.test(this.GSTNumber)) {
        this.isValidGST = true;
      } else {
        this.isValidGST = false;
      }
    },
    addBankFields() {
      let bankAccount = {
        bankIFSC: "",
        bankAccountNumber: "",
      };

      this.bankAccounts.push(bankAccount);
    },
    removeBankAccount(index) {
      if (this.bankAccounts.length > 1) {
        this.bankAccounts = this.bankAccounts.filter((bank) => {
          return bank != this.bankAccounts[index];
        });
      }
    },
    validateAndSendOTP() {
      let regPan = /^([0-9]){10}?$/;
      if (regPan.test(this.mobileNumber)) {
        
        var val = Math.floor(1000 + Math.random() * 9000);
        console.log(val);
        // this.sentOTP = val;
        this.sentOTP = '1234';
        this.getCountDown();
        this.isValidMobile = true;
        var data = JSON.stringify({
          "numbers": "91"+this.mobileNumber,
          // "message": "IWMS: "+ this.sentOTP +" is your OTP to register with Pune Municipal Corporation as Contractor. -INIWMS",
          "message": "IWMS : "+ this.sentOTP +" is your OTP to register with Pune Municipal Corporation as Contractor.- INIWMS",
          "sender": "INIWMS"
        });

        // var data = JSON.stringify({
        //   "numbers": "91" + this.mobileNumber,
        //   "message": "IWMS: "+ this.sentOTP +" is your OTP to register with Pune Municipal Corporation as Contractor.-INIWMS",
        //   "sender": "INIWMS"
        // });

        var config = {
          method: 'post',
          url: 'https://innomiseapi.com/vendor_api/public/api/sendsms',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };

        axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });


        var data = JSON.stringify({
          "company_name": this.companyName,
          "email": this.email,
          "subject": "IWMS PMC OTP for Registration",
          "message": "Your OTP is <b>"+ this.sentOTP +"</b>. Please do not desclose the OTP."
        });

        var config = {
          method: 'post',
          url: 'https://innomiseapi.com/vendor_api/public/api/sendMail',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };

        axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      } else {
        this.isValidMobile = false;
      }
    },
    verifyOTP() {
      // console.log(this.sentOTP);
      let trimedOTP = this.mobileOTP.split(" ").join("");
      if (this.sentOTP == trimedOTP) {
        this.isValidOTP = true;
      } else {
        this.isValidOTP = false;
      }
    },
    getCountDown() {
      var self = this;
      let interval = setInterval(function () {
        let timer = self.countDown;
        timer = timer.split(":");
        // console.log(timer, countTime);
        var minutes = timer[0];
        var seconds = timer[1];
        seconds -= 1;
        if (minutes < 0) return;
        else if (seconds < 0 && minutes != 0) {
          minutes -= 1;
          seconds = 59;
        } else if (seconds < 10 && length.seconds != 2) {
          seconds = "0" + seconds;
        }

        self.countDown = minutes + ":" + seconds;
        // console.log();
        if (minutes == 0 && seconds == 0) {
          clearInterval(interval);
          self.enableResendOTP = false;
        }
      }, 1000);
      // this.countDown = countTime;
    },
    getInfoPopup(popupContent) {
      this.$swal({
        title: popupContent.title,
        text: popupContent.text,
        icon: "info",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getCustomPopup(popupContent) {
      this.$swal({
        title: popupContent.title,
        text: popupContent.text,
        icon: popupContent.icon,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((okay)=>{
          // console.log(okay);
          // if(okay){
            this.isLoading = false;
            window.location.href = "https://pmciwms.in";
          // }
        })
    },
    getAddressDetails() {
      let pin = this.pincode;
      let details = {};
      axios.get(`https://api.postalpincode.in/pincode/${pin}`).then((data) => {
        // console.log(data.data[0]["PostOffice"][0].District);
        let pincodeDetails = data.data[0].PostOffice[0];
        details.city = pincodeDetails.District;
        details.state = pincodeDetails.State;
        details.country = pincodeDetails.Country;

        this.city = details.city;
        this.state = details.state;
        this.country = details.country;
      });
    },
  },
};

// Validtions with VeeValidate

extend("checkPAN", {
  validate: (value) => {
    let regPan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    return regPan.test(value);
  },
  message: "PAN number is invalid.",
});

extend("checkGST", {
  validate: (value) => {
    let regPan =
      /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9a-zA-Z]){1}([Z]){1}([0-9a-zA-Z]){1}?$/;
    return regPan.test(value);
  },
  message: "GST number is invalid.",
});

extend("checkIFSC", {
  validate: (value) => {
    let regPan = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
    return regPan.test(value);
  },
  message: "IFSC Code is invalid.",
});

extend("checkMobileNumber", {
  validate: (value) => {
    let regPan = /^([0-9]){10}?$/;
    return regPan.test(value);
  },
  message: "Mobile number must be contain 10 digits",
});

extend("isValidOTP", {
  validate: (value) => {
    let regPan = /^([0-9 ]){7}?$/;
    return regPan.test(value);
  },
  message: "Invalid OTP",
});
</script>

<style>
  #loading-animation{
    z-index: 1025;
    width: 100%;
    height: 100vh;
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    background: #3333336b;
    justify-content: center;
    color: #fff;
    font-weight: 900;
    font-size: 45px;
  }
</style>
